'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
interface DeviceInfo {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  userAgent: string;
}

/**
 * @description Hook for detecting device type
 */
export const useDeviceDetection = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      isMobile: false,
      isTablet: false,
      isDesktop: true,
      userAgent: ""
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [deviceInfo, setDeviceInfo] = useState(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const userAgent = navigator.userAgent;
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
      const isTablet = /iPad|Android(?=.*\bMobile\b)/i.test(userAgent) || window.innerWidth >= 768 && window.innerWidth <= 1024;
      const isDesktop = !isMobile && !isTablet;
      setDeviceInfo({
        isMobile,
        isTablet,
        isDesktop,
        userAgent
      });
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return deviceInfo;
};
export default useDeviceDetection;